import { render, staticRenderFns } from "./draft-list.vue?vue&type=template&id=5d961485"
import script from "./draft-list.vue?vue&type=script&lang=js"
export * from "./draft-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d961485')) {
      api.createRecord('5d961485', component.options)
    } else {
      api.reload('5d961485', component.options)
    }
    module.hot.accept("./draft-list.vue?vue&type=template&id=5d961485", function () {
      api.rerender('5d961485', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/deviceInfo-manage/product/draft-list.vue"
export default component.exports